export default "<div class=\"abstract-text\" *ngIf=\"text\">{{ text }}</div>\n";